export enum OtpAction {
  SignIn = 'SIGN_IN',
  SignUp = 'SING_UP',
}

export enum SystemPrivilege {
  // USER MANAGEMENT

  // Super Admin
  ViewSuperAdmin = 'VIEW_SUPER_ADMIN',

  // Broker admin
  CreateBrokerAdmin = 'CREATE_BROKER_ADMIN',
  EditBrokerAdmin = 'EDIT_BROKER_ADMIN',
  ViewBrokerAdmin = 'VIEW_BROKER_ADMIN',

  // Broker User
  CreateBrokerUser = 'Create_BROKER_USER',
  EditBrokerUser = 'EDIT_BROKER_USER',
  ViewBrokerUser = 'VIEW_BROKER_USER',

  // Broker User
  CreateUnderwriterAdmin = 'CREATE_UNDERWRITER_ADMIN',
  EditUnderwriterAdmin = 'EDIT_UNDERWRITER_ADMIN',
  ViewUnderwriterAdmin = 'VIEW_UNDERWRITER_ADMIN',

  // Underwriter User
  CreateUnderwriterUser = 'CREATE_UNDERWRITER_USER',
  EditUnderwriterUser = 'EDIT_UNDERWRITER_USER',
  ViewUnderwriterUser = 'VIEW_UNDERWRITER_USER',

  // Client Admin
  CreateClientAdmin = 'CREATE_CLIENT_ADMIN',
  EditClientAdmin = 'EDIT_CLIENT_ADMIN',
  ViewClientAdmin = 'VIEW_CLIENT_ADMIN',

  // Client User
  CreateClientUser = 'CREATE_CLIENT_USER',
  EditClientUser = 'EDIT_CLIENT_USER',
  ViewClientUser = 'VIEW_CLIENT_USER',

  // Club Admin
  CreateClubAdmin = 'CREATE_CLUB_ADMIN',
  EditClubAdmin = 'EDIT_CLUB_ADMIN',
  ViewClubAdmin = 'VIEW_CLUB_ADMIN',

  // Club User
  CreateClubUser = 'CREATE_CLUB_USER',
  EditClubUser = 'EDIT_CLUB_USER',
  ViewClubUser = 'VIEW_CLUB_USER',

  // Event Admin
  CreateEventAdmin = 'CREATE_EVENT_ADMIN',
  EditEventAdmin = 'EDIT_EVENT_ADMIN',
  ViewEventAdmin = 'VIEW_EVENT_ADMIN',

  // Event User
  CreateEventUser = 'CREATE_EVENT_USER',
  EditEventUser = 'EDIT_EVENT_USER',
  ViewEventUser = 'VIEW_EVENT_USER',

  // Board User
  CreateBoardUser = 'CREATE_BOARD_USER',
  EditBoardUser = 'EDIT_BOARD_USER',
  ViewBoardUser = 'VIEW_BOARD_USER',

  // Approve User
  ViewUserApproval = 'VIEW_USER_APPROVAL',
  ManageUserApproval = 'MANAGE_USER_APPROVAL',

  // DIGITAL CHECKLIST

  // Event management
  CreateEvent = 'CREATE_EVENT',
  EditEvent = 'EDIT_EVENT',
  ViewEvent = 'VIEW_EVENT',

  // Event Data
  ViewEventData = 'VIEW_EVENT_DATA',

  // Closed Event
  ManageClosedEvent = 'MANAGE_CLOSED_EVENT',
  ViewClosedEvent = 'VIEW_CLOSED_EVENT',

  // Aggregated Event Report
  ManageAggregatedEventReport = 'MANAGE_AGGREGATED_EVENT_REPORT',
  ViewAggregatedEventReport = 'VIEW_AGGREGATED_EVENT_REPORT',

  // Post Event Report
  ManagePostEventReport = 'MANAGE_POST_EVENT_REPORT',
  ViewPostEventReport = 'VIEW_POST_EVENT_REPORT',

  // On Day Prompt
  ManageOnDayPrompt = 'MANAGE_ON_DAY_PROMPT',
  ViewOnDayPrompt = 'VIEW_ON_DAY_PROMPT',

  // Incident Form
  ManageIncidentForm = 'MANAGE_INCIDENT_FORM',
  ViewIncidentForm = 'VIEW_INCIDENT_FORM',

  // Safety Briefing
  ManageSafetyBriefing = 'MANAGE_SAFETY_BRIEFING',
  ViewSafetyBriefing = 'VIEW_SAFETY_BRIEFING',

  // Attendance Confirmation
  ManageAttendanceConfirmation = 'MANAGE_ATTENDANCE_CONFIRMATION',
  ViewAttendanceConfirmation = 'VIEW_ATTENDANCE_CONFIRMATION',

  // Event Member
  ManageEventMember = 'MANAGE_EVENT_MEMBER',
  ViewEventMember = 'VIEW_EVENT_MEMBER',
  RemoveEventMember = 'REMOVE_EVENT_MEMBER',

  // Task Management
  CreateTask = 'CREATE_TASK',
  EditTask = 'EDIT_TASK',
  ViewTask = 'VIEW_TASK',
  ManageTaskComment = 'MANAGE_TASK_COMMENT',
  ViewTaskComment = 'VIEW_TASK_COMMENT',

  // Incident Report
  CreateIncidentReport = 'CREATE_INCIDENT_REPORT',
  ViewIncidentData = 'VIEW_INCIDENT_DATA',

  // Reporting
  ViewReporting = 'VIEW_REPORTING',

  // Organization
  CreateOrganization = 'CREATE_ORGANIZATION',
  ViewOrganization = 'VIEW_ORGANIZATION',
  EditOrganization = 'EDIT_ORGANIZATION',

  // Client Group
  CreateClientGroup = 'CREATE_CLIENT_GROUP',
  ViewClientGroup = 'VIEW_CLIENT_GROUP',
  EditClientGroup = 'EDIT_CLIENT_GROUP',

  // Assign User To Organization
  AssignUserToOrganization = 'ASSIGN_USER_TO_ORGANIZATION',

  // DEPRECATED

  /** @deprecated No longer use this privilege */
  ManageIncident = 'MANAGE_INCIDENT',
  /** @deprecated No longer use this privilege */
  ViewIncident = 'VIEW_INCIDENT',
  /** @deprecated No longer use this privilege */
  ManageIncidentReport = 'MANAGE_INCIDENT_REPORT',
  /** @deprecated No longer use this privilege */
  ViewIncidentReport = 'VIEW_INCIDENT_REPORT',
}

export enum SystemRole {
  SuperAdmin = 'Super Admin',
  BrokerAdmin = 'Broker Admin',
  BrokerUser = 'Broker User',
  ClientAdmin = 'Client Admin',
  ClientUser = 'Client User',
  ClubAdmin = 'Club Admin',
  ClubUser = 'Club User',
  EventAdmin = 'Event Admin',
  EventUser = 'Event User',
  UnderwriterAdmin = 'Underwriter Admin',
  UnderwriterUser = 'Underwriter User',
  BoardUser = 'Board User',
}
